import '../../styles/PrivateLayout/PrivateLayout.css';

import { SettingOutlined }     from '@ant-design/icons';
import { CaretDownOutlined }   from '@ant-design/icons';
import { UserOutlined }        from '@ant-design/icons';
import React                   from 'react';
import { Link }                from 'react-router-dom';
import { Menu }                from 'antd';
import { Layout }              from 'antd';
import { observer }            from 'mobx-react';
import { Tooltip }             from 'antd';
import { privateLayoutStore }  from 'stores/index';
import FormattedMessageWrapper from 'components/App/FormattedMessageWrapper';
import SwitchLanguage          from 'components/App/SwitchLanguage';
import rights                  from 'utils/rights';
import currentSession          from 'utils/currentSession';
import { ROLE_SUPER_ADMIN }    from 'constants/RoleReferences';
import { ROLE_ADMIN }          from 'constants/RoleReferences';
import { ROLES_CONVERTER }     from 'utils/constants';
import ShowModel               from 'models/ShowModel';

import defaultLogoUrl from '/images/default-logo.png?url';

const ShowsMenu = observer(() => {

  const currentShowId = privateLayoutStore.showId || '';

  const showMenuItems: MenuItem[] = [];

  privateLayoutStore.showCollection.forEach((show: ShowModel) => {
    showMenuItems.push({
      key: show?.id?.toString() || '',
      label: (
          <Tooltip placement="bottom" title={show.showName}>
            <Link to={`/salons/${show.id}`}>
              <div className="header-menu-item-show">
                <div className="show-logo">
                  <img
                      alt="logo"
                      src={show.logoObjectUrl ? show.logoObjectUrl : defaultLogoUrl}
                  />
                </div>
              </div>
            </Link>
          </Tooltip>
      ),
    });
  });

  if (!showMenuItems.length) {
    showMenuItems.push({
      disabled: true,
      key: 'no_shows',
      label: <FormattedMessageWrapper id="Aucun salon." />,
    });
  }

  return (
      <Menu
          defaultSelectedKeys={[currentShowId.toString()]}
          items={showMenuItems}
          mode="horizontal"
          selectedKeys={[currentShowId.toString()]}
          style={{
            ...headerMenuStyle,
          }}
      />
  );
});

type MenuItem = {
  children?: MenuItem[];
  disabled?: boolean;
  key: string;
  label: React.JSX.Element;
  onClick?: () => void;
};

const PrivateLayoutHeader = observer(({
  logout,
  onSwitchTo,
}: {
  logout: () => void;
  onSwitchTo: (value: any) => Promise<void>;
  user: {
    user_informations: Record<string, string>;
  };
}) => {
  const adminsMenuItems: MenuItem[] = [];

  const currentShowId = privateLayoutStore.showId || '';

  if (rights.for.show.list) {
    adminsMenuItems.push({
      key: 'show_list',
      label: (
          <Link to="/salons">
            <FormattedMessageWrapper id="Liste salons" />
          </Link>
      ),
    });
  }

  if (rights.for.user.list) {
    adminsMenuItems.push({
      key: 'administrators',
      label: (
          <Link to="/administrateurs">
            <FormattedMessageWrapper id="Administrateurs" />
          </Link>
      ),
    });
  }

  if (rights.for.provider.list) {
    adminsMenuItems.push({
      key: 'providers',
      label: (
          <Link to="/prestataires">
            <FormattedMessageWrapper id="Prestataires" />
          </Link>
      ),
    });
  }

  if (rights.for.advertiser.list) {
    adminsMenuItems.push({
      key: 'advertisers',
      label: (
          <Link to="/annonceurs">
            <FormattedMessageWrapper id="Annonceurs" />
          </Link>
      ),
    });
  }

  if (rights.for.layoutType.list) {
    adminsMenuItems.push({
      key: 'layoutTypes',
      label: (
          <Link to="/layout-types">
            <FormattedMessageWrapper id="Types d'aménagements" />
          </Link>
      ),
    });
  }

  const { user } = currentSession;
  let role;

  if (user.roles.includes(ROLE_SUPER_ADMIN) || user.roles.includes(ROLE_ADMIN)) {
    role = <FormattedMessageWrapper id="Administrateur" />;
  } else {
    role = ROLES_CONVERTER[user.roles[0]];
  }

  const rightMenuItems: MenuItem[] = [
    {
      disabled: true,
      key: 'switch-language',
      label: <SwitchLanguage iconMode onSwitchTo={onSwitchTo} />,
    },
    {
      disabled: true,
      key: 'user-informations',
      label: (
          <>
            {user.user_informations && (
                <div
                    style={{
                      fontSize: 14,
                      lineHeight: '16px',
                      textAlign: 'center',
                    }}
                >
                  {`${user.user_informations.firstName} ${user.user_informations.lastName}`}
                  {role && (
                      <><br />{`(`}{role}{`)`}</>
                  )}
                </div>
            )}
          </>
      ),
    },
  ];

  if (adminsMenuItems.length) {
    rightMenuItems.push({
      children: adminsMenuItems,
      key: 'settings',
      label: (
          <>
            <SettingOutlined /> <CaretDownOutlined />
          </>
      ),
    });
  }

  rightMenuItems.push({
    children: [
      {
        key: 'legal-mentions',
        label: (
            <Link to="/mentions-legales">
              <FormattedMessageWrapper id="Mentions légales" />
            </Link>
        ),
      },
      {
        key: 'user-account',
        label: (
            <Link to="/compte">
              <FormattedMessageWrapper id="Compte" />
            </Link>
        ),
      },
      {
        key: 'logout',
        label: <FormattedMessageWrapper id="Déconnexion" />,
        onClick: () => logout(),
      },
    ],
    key: 'account',
    label: (
        <>
          <UserOutlined /> <CaretDownOutlined />
        </>
    ),
  });

  return (
      <Layout.Header style={headerStyle}>
        <div
            style={{
              flex: 1,
              overflow: 'hidden',
            }}
        >
          <ShowsMenu />
        </div>

        <div
            style={{
              width: 448,
            }}
        >
          <Menu
              defaultSelectedKeys={currentShowId ? [currentShowId.toString()]: []}
              items={rightMenuItems}
              mode="horizontal"
              style={{
                ...headerMenuStyle,
                alignItems: 'center',
                display: 'flex',
              }}
          />
        </div>
      </Layout.Header>
  );
});

const headerStyle = {
  background: '#fff',
  display: 'flex',
  justifyContent: 'space-between',
  padding: 0,
};

const headerMenuStyle = {
  height: '64px',
};

export default PrivateLayoutHeader;
